const workflowType = {
  GENERIC_INDENT: 1,
};

const workflowFieldAccess = {
  WRITE: 1,
  READ: 2,
  READ_WRITE: 3,
};

const workflowActionId = {
  CANCELLED: -1,
  CREATED: 0,
  CUSTOMER_CLEARANCE_DONE: 1,
  SI_SUBMISSION_DONE: 2,
  VESSEL_SAILED: 3,
  BOL_ISSUED: 4,
  VESSEL_REACHED: 5,
  HANDOVER_TO_CONCOR: 6,
  CONTAINERS_RECEIVED: 7,
  CONSIGNMENT_PICKED_FROM_ORIGIN: 8,
  VESSEL_SAILED_FROM_POL: 9,
  CONTAINER_RECEIVED_AT_POD: 10,
  CONSIGNMENT_RECEIVED: 11,
  BOE_FILED: 12,
  EXAMINATION_DONE: 13,
  SUBMIT_DUTY_CHALLAN: 14,
  VEHICLE_REACHED: 15,
  CUSTOM_CLEARANCE_AT_POD: 16,
  DELIVERED_TO_CONSIGNEE: 17,
  SHIPMENT_RECEIVED_AT_AIRPOT: 18,
  LOAD_AND_STOW_CARGO: 19,
  HANDEDOVER_TO_AIRLINES: 20,
  AWB_ISSUED: 21,
  SHIPMENT_DEPARTURE: 22,
  FLIGHT_REACHED: 23,
  PICK_UP_COMPLETE: 24,
  SHIPMENT_RECEIVED_AT_DESTINATION: 25,
  SHIPMENT_DEPARTURED_FROM_POL: 26,
  SHIPMENT_RECEIVED_AT_POD: 27,
  ORIGIN_CUSTOM_CLEARED: 28,
  LINKED_TO_NEXT_LEG: 29,
};

const workflowActionStatus = [
  {
    id: -1,
    name: 'CANCELLED',
    label: 'CANCELLED',
    color: 'status-red',
  },
  {
    id: 0,
    name: 'CREATED',
    label: 'CREATED',
    color: 'status-purple',
  },
  {
    id: 1,
    name: 'CUSTOMS_CLEARANCE_DONE',
    label: 'CUSTOMS CLEARED',
    color: 'status-pink',
  },
  {
    id: 2,
    name: 'SI_SUBMISSION_DONE',
    label: 'SI SUBMITTED',
    color: 'status-teal',
  },
  {
    id: 3,
    name: 'VESSEL_SAILED',
    label: 'VESSEL SAILED',
    color: 'status-blue',
  },
  {
    id: 4,
    name: 'BOL_ISSUED',
    label: 'BOL ISSUED',
    color: 'status-yellow',
  },
  {
    id: 5,
    name: 'VESSEL_REACHED',
    label: 'VESSEL REACHED',
    color: 'status-green',
  },
  {
    id: 6,
    name: 'HANDOVER_TO_CONCOR',
    label: 'HANDOVER TO CONCOR',
    color: 'status-blue',
  },
  {
    id: 7,
    name: 'CONTAINERS_RECEIVED',
    label: 'CTR RECEIVED',
    color: 'status-teal',
  },
  {
    id: 8,
    name: 'CONSIGNMENT_PICKED_FROM_ORIGIN',
    label: 'picked from origin',
    color: 'status-teal',
  },
  {
    id: 9,
    name: 'VESSEL_SAILED_FROM_POL',
    label: 'Vessel sailed from PoL',
    color: 'status-teal',
  },
  {
    id: 10,
    name: 'CONTAINER_RECEIVED_AT_POD',
    label: 'Container received at PoD',
    color: 'status-teal',
  },
  {
    id: 11,
    name: 'CONSIGNMENT_RECEIVED',
    label: 'Consignment received',
    color: 'status-teal',
  },
  {
    id: 12,
    name: 'BOE_FILED',
    label: 'BoE filed',
    color: 'status-teal',
  },
  {
    id: 13,
    name: 'EXAMINATION_DONE',
    label: 'Examination done',
    color: 'status-teal',
  },
  {
    id: 14,
    name: 'SUBMIT_DUTY_CHALLAN',
    label: 'Submit Duty Challan',
    color: 'status-teal',
  },
  {
    id: 15,
    name: 'VEHICLE_REACHED',
    label: 'Vehicle reached',
    color: 'status-teal',
  }, {
    id: 16,
    name: 'CUSTOM_CLEARANCE_AT_POD',
    label: 'Custom Clearance At Port Of Discharge',
    color: 'status-teal',
  }, {
    id: 17,
    name: 'DELIVERED_TO_CONSIGNEE',
    label: 'Delivered To Consignee',
    color: 'status-teal',
  },
  {
    id: 18,
    name: 'SHIPMENT_RECEIVED_AT_AIRPOT',
    label: 'Shipment Received At Airport',
    color: 'status-teal',
  },
  {
    id: 19,
    name: 'LOAD_AND_STOW_CARGO',
    label: 'Load And Stow Cargo',
    color: 'status-teal',
  },
  {
    id: 20,
    name: 'HANDEDOVER_TO_AIRLINES',
    label: 'Handed Over To Airlines',
    color: 'status-teal',
  },
  {
    id: 21,
    name: 'AWB_ISSUED',
    label: 'AWB Issued',
    color: 'status-teal',
  },
  {
    id: 22,
    name: 'SHIPMENT_DEPARTURE',
    label: 'Shipment Departure',
    color: 'status-teal',
  },
  {
    id: 23,
    name: 'FLIGHT_REACHED',
    label: 'Flight Reached',
    color: 'status-teal',
  },
  {
    id: 24,
    name: 'PICK_UP_COMPLETE',
    label: 'Pickup Complete',
    color: 'status-teal',
  },
  {
    id: 25,
    name: 'SHIPMENT_RECEIVED_AT_DESTINATION',
    label: 'Shipment Received At Destination',
    color: 'status-teal',
  },
  {
    id: 26,
    name: 'SHIPMENT_DEPARTURED_FROM_POL',
    label: 'Shipment Departured From Pol',
    color: 'status-teal',
  },
  {
    id: 27,
    name: 'SHIPMENT_RECEIVED_AT_POD',
    label: 'Shipment Received At POD',
    color: 'status-teal',
  },
  {
    id: 28,
    name: 'ORIGIN_CUSTOM_CLEARED',
    label: 'Origin Custom Cleared',
    color: 'status-teal',
  },
  {
    id: 29,
    name: 'LINKED_TO_NEXT_LEG',
    label: 'Linked To Next Leg',
    color: 'status-teal',
  },
];

const workflowActionIdMapping = {
  '-1': 'CANCELLED',
  0: 'CREATED',
  1: 'CUSTOMS_CLEARANCE_DONE',
  2: 'SI_SUBMISSION_DONE',
  3: 'VESSEL_SAILED',
  4: 'BOL_ISSUED',
  5: 'VESSEL_REACHED',
  6: 'HANDOVER_TO_CONCOR',
  7: 'CONTAINERS_RECEIVED',
  8: 'CONSIGNMENT_PICKED_FROM_ORIGIN',
  9: 'VESSEL_SAILED_FROM_POL',
  10: 'CONTAINER_RECEIVED_AT_POD',
  11: 'CONSIGNMENT_RECEIVED',
  12: 'BOE_FILED',
  13: 'EXAMINATION_DONE',
  14: 'SUBMIT_DUTY_CHALLAN',
  15: 'VEHICLE_REACHED',
  16: 'CUSTOM_CLEARANCE_AT_POD',
  17: 'DELIVERED_TO_CONSIGNEE',
  18: 'SHIPMENT_RECEIVED_AT_AIRPOT',
  19: 'LOAD_AND_STOW_CARGO',
  20: 'HANDEDOVER_TO_AIRLINES',
  21: 'AWB_ISSUED',
  22: 'SHIPMENT_DEPARTURE',
  23: 'FLIGHT_REACHED',
  24: 'PICK_UP_COMPLETE',
  25: 'SHIPMENT_RECEIVED_AT_DESTINATION',
  26: 'SHIPMENT_DEPARTURED_FROM_POL',
  27: 'SHIPMENT_RECEIVED_AT_POD',
  28: 'ORIGIN_CUSTOM_CLEARED',
  29: 'LINKED_TO_NEXT_LEG',
};

const workflowFieldId = {
  LET_EXPORT_ORDER_DATE: 1,
  SI_FILLING_DATE: 2,
  ACTUAL_VESSEL_SAILING_DATE: 3,
  BL_ISSUE_DATE: 4,
  BL_NUMBER: 5,
  REACHED_DATE: 6,
  TR_NUMBER: 7,
  TR_HANDOVER_DATE: 8,
  RAILMENT_DATE: 9,
  VESSEL_NAME: 10,
  SHIPPING_BILL: 11,
  BL_DRAFT: 12,
  BL_COPY: 13,
  PICK_UP_DATE: 14,
  EXPECTED_HANDOVER_DATE_AT_POL: 15,
  UPDATED_INVOICE_AND_PACKING: 16,
  BOL_NUMBER: 17,
  BOL: 18,
  GIGM_NUMBER: 19,
  GIGM_DATE: 20,
  LIGM_NUMBER: 21,
  LIGM_DATE: 22,
  PRE_ALERT: 23,
  RAIL_OUT_DATE_TIME: 24,
  EMPTY_CONTAINER_RETURN_DATE_TIME: 25,
  EMPTY_CONTAINER_RETURN_LOCATION: 26,
  BOE_NUMBER: 27,
  BOE_FILE_DATE: 28,
  BOE_COPY: 29,
  CUSTOM_CLEARANCE_DATE_TIME: 30,
  EXAMINTAION_DATE_TIME: 31,
  EXAMINATION_COPY: 32,
  CHALLAN_COPY: 33,
  DO_NUMBER: 34,
  DO_DATE: 35,
  DO_SHIPPLING_LIN: 36,
  DO_HOUSE_DO: 37,
  PIC_OF_CONTAINER_SEAL_AND_VEHICLE_CONDITIONS: 38,
  VGM_DETAILS: 39,
  ODEX_SUBMISSION_DOCUMENT: 40,
  CONTAINER_RECEIVED_DATE: 41,
  VEHICLE_NUMBER: 42,
  OUT_OF_CHARGE_DATE: 43,
  DUTY_CHALLAN_DATE: 44,
  CONTAINER_LOCATION: 45,
  CONTAINER_RECEIVE_DATE: 46,
  CONCOR_RECEIPT: 47,
  CONTAINER_NO: 48,
  LINE_SEAL_NO: 49,
  CONTAINER_TYPE: 50,
  CUSTOM_CLEARANCE_DATE_TIME_AT_POD: 51,
  CONSIGNMENT_DELIVERY_TIME: 52,
  SHIPPING_LINE: 53,
  FDS_UPDATE: 54,
  FLIGHT_NUMBER: 55,
  FLIGHT_DATE: 56,
  AWB_NUMBER: 57,
  AWB_DATE: 58,
  DEPARTURE_DATE: 59, // SCHEDULED DEPARTURE
  ETA_AT_DESTINATION: 60,
  IGM_NUMBER: 61,
  IGM_DATE: 62,
  AWB_COPY: 63,
  DELIVERED_DATE: 64,
  CONSIGNMENT_PICKED_FROM_ORIGIN: 65,
};

const workflowDataType = {
  TEXT: 1,
  DATE: 2,
  DROP_DOWN: 3,
  CHECK_BOX: 4,
  RADIO_BUTTON: 5,
  ATTACHMENT: 6,
};

const workflowSubInputType = {
  PORT: 1,
  CONTAINER_TYPE: 2,
};

const workflowActionSkipType = {
  NONE: 0,
  SEA_PORT_EXIM: 1,
  SKIP_HOC_ON_SAME_PORT: 2,
};

module.exports = {
  workflowType,
  workflowFieldAccess,
  workflowActionId,
  workflowActionStatus,
  workflowFieldId,
  workflowDataType,
  workflowActionIdMapping,
  workflowActionSkipType,
  workflowSubInputType,
};
